import { each, flow, get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FaSpinner } from 'react-icons/fa';
import { Modal as BootstrapModal } from 'react-bootstrap/lib';
import { change, formValueSelector, getFormSyncErrors, getFormValues, reduxForm } from 'redux-form';
import { Alert, Button, Col, Form, ModalBody, ModalHeader, ModalTitle, Row } from 'react-bootstrap';
import { IBrandingActions, II18nMessages } from '../../../../services/branding/models';
import { IChannel, IPolicyApplication, ITraveller } from '../../../../data/api/models';
import { IPaymentMethodActions } from '../../../../services/paymentMethod/models';
import { paymentMethodActions } from '../../../../services/paymentMethod/actions';
import { IStore } from '../../../../redux/IStore';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import ChangeRenewalType from '../ChangeRenewalType';
import { renderProductDefinition } from '../../../../scenes/CustomerAreaNew/scenes/MakeAChange/Helpers';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { renewalTypeSelectionEnum } from '../../../../scenes/Quote/scenes/Payment/components/YourRenewal';
import ConsentAndIntentPortal, { IPaymentMethod } from '../../../ConsentAndIntentPortal';
import { shouldIgnoreCardPermissions } from '../../../../helpers/Quote';

interface IPaymentWithCardModalProps {
  show: boolean;
  closeModal: any;
  openCardTransactionModal: any;
  i18n: II18nMessages;
  leadTraveller: ITraveller;
  dispatch: any;
  change: any;
  channel: IChannel;
  reuseCustomerAddress: boolean;
  permissions: boolean;
  travellers: ITraveller[];
  isMta: boolean;
  showRenewal: boolean;
  paymentMethods?: IPaymentMethod[];
  quote: IQuoteState;
  actions: {
    paymentMethod: IPaymentMethodActions;
    quote: IQuoteActions;
    branding: IBrandingActions;
  }
  customerId: string;
  policyId: string;
  formValues: IPolicyApplication;
  submitting: boolean,
  submitFailed: boolean,
  valid: boolean,
  handleSubmit: any;
  changeRenewalType: boolean,

}

interface IPaymentWithCardModalState {
  isSubmitting: boolean;
  error: string;
}

class PaymentWithCardModal extends React.Component<IPaymentWithCardModalProps, IPaymentWithCardModalState> {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      error: '',
    };

    props.actions.change('quote', 'permissions', true);
  }

  private renderConsentAndIntent = () => {
    const { isMta, paymentMethods = [] } = this.props;
    return (
      <ConsentAndIntentPortal
        permissions={true}
        leadTraveller={this.props.leadTraveller}
        i18n={this.props.i18n}
        change={this.props.change}
        channel={this.props.channel}
        dispatch={this.props.dispatch}
        reuseCustomerAddress={this.props.reuseCustomerAddress}
        isMta={isMta}
        paymentMethods={paymentMethods}
        travellers={this.props.travellers}
        showRenewal={false}
        showSectionTitle={false}
      />
    );
  }

  private renderChangeRenewalType = () => {
    const { actions, formValues, change } = this.props;
    const renderDefinition = renderProductDefinition(actions.branding.getProduct())
    const ignorePermissions = shouldIgnoreCardPermissions();


    if (!formValues.permissions && !ignorePermissions) {
      change('renewalStatusChange', renewalTypeSelectionEnum.MANUAL)
    }

    return (
      <ChangeRenewalType
        renderDefinition={renderDefinition}
        allowAutoRenewal={formValues.permissions}
        change={this.props.change}
        renewalStatusValue={formValues.renewalStatusChange}
        dispatch={this.props.dispatch}
        ignorePermissions={ignorePermissions}
        {...this.props}/>
    )
  }

  private scrollToTop = () => {
    if (process.env.BROWSER) {
      window.scrollTo(0, 0);
    }
  }

  private handleSubmit = () => {
    const { actions, openCardTransactionModal, formValues, closeModal, dispatch, change, quote } = this.props;

    this.setState({
      isSubmitting: true,
      error: '',
    });

    const channelKey = get(formValues, 'channel.key')
    const renewalStatusChange = get(formValues, 'renewalStatusChange');
    formValues.purchasedFromB2C = true;
    if (formValues.quoteType === 'renewal') {
      formValues.portal = true;
    }

    if (renewalStatusChange) {
      formValues.renewalStatus = renewalStatusChange
    }

    // tslint:disable-next-line:prefer-conditional-expression
    if (!channelKey) {
      formValues.purchaseChannel = 'admiral-b2c';
    } else {
      formValues.purchaseChannel = ['call-centre', 'call-centre-renewal'].includes(channelKey) ? 'admiral-b2c' : channelKey;
    }

    const fraudCheck = get(quote, 'application.premiums[0].information.fraudCheck', false);
    formValues.fraudCheck = {
      answer: 'not-required',
    };

    const isAggregator = get(formValues, 'channel.channelType', '') === 'AGG';

    if (
      isAggregator && quote.application.quoteType === 'renewal'
      && ['msm', 'msm-renewal', 'tsm', 'tsm-renewal'].includes(get(formValues, 'channel.key'))
    ) {
      formValues.nextTermRenewalStatus = 'auto';
    }

    if (fraudCheck) {
      return actions.quote.fraudCheck(formValues.id)
        .then((data) => {
          dispatch(change('fraudCheck', data.meta));
          // Save the policy application
          actions.quote.updatePolicyApplication(true)
            .then((application) => {
              if (data.meta.answer === 'deny') {
                actions.quote.error('We are unable to complete this transaction.' +
                  ' We sincerely apologise for the inconvenience caused.');
                this.scrollToTop();
                actions.quote.setWaitForPurchaseToComplete(false);
                return;
              }
            })
            .catch((error) => {
              actions.quote.setWaitForPurchaseToComplete(false);
            });
        })
        .catch((error) => {
          actions.quote.setWaitForPurchaseToComplete(false);
        });
    }

    Promise.resolve(actions.quote.updatePolicyApplication(true, formValues)).then(() => {
      Promise.resolve(actions.quote.purchase(formValues))
        .then((data) => {
          closeModal();
          this.scrollToTop();
        })
        .catch((error) => {
          // actions.quote.setWaitForPurchaseToComplete(false);

          let rethrow = true;
          let message = null;

          each(error.response.data.errors, (e: any) => {
            if (e.id !== 'redirect-to-provider') {
              message = e.detail;
              return;
            }

            openCardTransactionModal(e.data.transactionId);
            rethrow = false;
          });

          this.setState({
            isSubmitting: false,
          });
          closeModal();

          if (!rethrow) {
            return;
          }

          if (message) {
            actions.quote.error(message);
          }

          throw error;
        });
    }).catch((error) => {
      console.log(error)
    });
  }

  public render() {
    const { show, closeModal, handleSubmit, submitting, submitFailed, valid, changeRenewalType = true } = this.props;
    const { isSubmitting, error } = this.state;
    return (
      <BootstrapModal
        show={show}
        onHide={closeModal}
        keyboard={false}
        backdrop="static"
      >
        <ModalHeader closeButton={true}>
          <ModalTitle>Payment</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Form horizontal={true} autoComplete="off" onSubmit={handleSubmit(this.handleSubmit)}>
            {changeRenewalType && this.renderChangeRenewalType()}
            {this.renderConsentAndIntent()}
            {error && (
              <Alert bsStyle={'danger'}>{error}</Alert>
            )}
            <Row>
              <Col sm={12}>
                <Button
                  id="continue"
                  bsStyle="primary"
                  className="pull-right"
                  type={'submit'}
                  disabled={submitting || (submitFailed && !valid)}
                >
                  {isSubmitting && (
                    <FaSpinner className="fa-spin"/>
                  )}
                  CONTINUE
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </BootstrapModal>
    );
  }
}

let selector;

const PAY_FORM_NAME = 'quote';

export default flow([
  reduxForm({
    form: PAY_FORM_NAME,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
  }),
  (component) => {
    selector = formValueSelector(PAY_FORM_NAME);

    return component;
  },
  connect(
    (state: IStore) => {
      const reuseCustomerAddress = selector(state, 'reuseCustomerAddress');
      const formValues = getFormValues(PAY_FORM_NAME)(state);
      const synchronousError = getFormSyncErrors('quote')(state);

      return {
        channel: state.branding.channel,
        auth: state.auth,
        i18n: state.branding.i18n,
        quote: state.quote,
        reuseCustomerAddress,
        formValues,
        synchronousError
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        change: bindActionCreators(change, dispatch),
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      }
    })
  ),
])(PaymentWithCardModal);
